export default __webpack_public_path__ + "static/media/tigerbox_touch_yellow.4322dee4.png";